import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community';


interface BooleanFilterParams extends IFilterParams{
  selectedValue: string;
  booleanValue: boolean | null;
}

/* custom ag grid filter for boolean/null columns */
@Component({
  selector: 'app-boolean-filter',
  templateUrl: './boolean-filter.component.html',
  styleUrls: ['./boolean-filter.component.scss']
})
export class BooleanFilterComponent implements IFilterAngularComp {
  selectedValue: string = 'all';
  params: any;

  agInit(params: IFilterParams){
    this.params = params;
  }

  // if filter is set to active, grid will show filter icon in the column header and 
  // will be included in the filtering of the data
  isFilterActive(){
    return this.selectedValue !== 'all';
  }

  // returns filter state
  getModel(): any{
    return { value: this.selectedValue };
  }

  // restore filter state. called by grid after gridApi.setFilterModel(model) is called
  // when filter is cleared, grid will pass undefined/null
  setModel(model: any){
    this.selectedValue = model ? model.value : 'all';
  }

  doesFilterPass(params: IDoesFilterPassParams<any>): boolean {
    switch(this.selectedValue){
      case 'all':
        return true;
      case 'yes':
        if(params.data.received_in)
          return true
        return false
      case 'no':
        if(params.data.received_in)
          return false
        return true
      default:
        return false;
    }
  }
}
